export enum TestingPageScreenState {
  SendEmails = 1,
  SendSentryError = 2
}
